// @flow

export const FETCH_FFC_DATA: string = 'FETCH_FFC_DATA';
export const SET_ERROR_TYPE: string = 'SET_ERROR_TYPE';
export const FETCH_COMPANION_FFC_DATA: string = 'FETCH_COMPANION_FFC_DATA';
export const FETCH_VIDEO_DATA: string = 'FETCH_VIDEO_DATA';
